<template>
  <div class="login">
    <div class="flex h-screen bg-indigo-100">
      <div class="container m-auto">
        <form
          form v-on:submit.prevent="send"
          class="container mx-auto max-w-md rounded-lg overflow-hidden shadow-lg bg-white"
        >
          <div class="px-6 pt-6 pb-6">
            <!-- <div class="flex flex-col justify-start mb-4">
              <div class=" content-center font-medium font-sans text-3xl mb-1 text-gray-800">Sign in to Convodo</div>
              <router-link
              class="text-gray-600 text-sm"
              to="/signup">
                or <span class="text-indigo-600 underline">create an account</span>
              </router-link>
            </div> -->
            <div class="flex flex-col justify-center align-center mb-2">
              <div class="self-center font-medium font-sans text-3xl text-gray-800">Sign in to Convodo</div>
              <router-link
              class="self-center text-gray-600 text-sm"
              to="/signup">
                or <span class="text-indigo-600 underline">create an account</span>
              </router-link>
            </div>

            <!-- Email -->
            <label
              class="pt-4 block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              for="email">
              Email
            </label>
            <input
              v-model.trim="$v.formResponses.email.$model"
              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              type="email"
              placeholder="jane.doe@acme.com"
              required
            >
            <p v-if="this.invalid">
              <span v-if="!$v.formResponses.email.required" class="text-red-500 text-xs italic mt-1 ml-1">Please fill out your email.</span>
              <span v-if="!$v.formResponses.email.email" class="text-red-500 text-xs italic mt-1 ml-1">Please fill out a valid email.</span>
            </p>

            <!-- Password -->
            <label
              class="pt-4 block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              for="password">
              Password
            </label>
            <input
              v-model.trim="$v.formResponses.password.$model"
              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              type="password"
              placeholder="Password"
              required
            >
            <p v-if="this.invalid">
              <span v-if="!$v.formResponses.password.minLength" class="text-red-500 text-xs italic mt-1 ml-1">Please ensure your password is longer than 6 characters.</span>
            </p>

            <p class="text-red-500 text-xs italic">
              <span>{{$v.password}}</span>
            </p>
            <p v-if="this.error">
              <span class="text-red-500 text-xs italic mt-1 ml-1">{{this.error}}</span>
            </p>
            <div class="flex flex-col content-center">
              <button
                @click.prevent="submitLogin()"
                class="self-center bg-indigo-500 hover:bg-indigo-700 mt-8 justify-center text-white font-medium text-xl py-2 px-6 rounded-full"
              >
                Sign in
              </button>
              <!-- TODO: Add in a forgot your password screen -->
              <!-- <span class="self-center text-sm text-indigo-600 underline mt-4">Forgot your password?</span> -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, email, minLength } from 'vuelidate/lib/validators'
  // import firebase from "firebase";
  import firebase from '@/utils/firebase'


  export default {
    name: 'login',
    data () {
      return {
        formResponses: {
          email: '',
          password: '',
        },
        email: '',
        password: '',
        error: '',
        invalid: false,
      }
    },

    validations: {
      formResponses: {
        email: {
          required,
          email,
        },
        password: {
          required,
          minLength: minLength(6)
        }
      }
    },

    methods: {
      submitLogin() {
        console.log(this.$v)
        this.invalid = this.$v.formResponses.$invalid;
        if(!this.invalid){
          firebase.auth()
            .signInWithEmailAndPassword(this.formResponses.email, this.formResponses.password)
            .then(data => {
              this.$router.replace({name:"Conversations"});
            })
            .catch(err => {
              if(err.code == 'auth/user-not-found'){
                this.error = "Hmm, we don't recognize that email. Please try again."
              } else if(err.code == 'auth/wrong-password'){
                this.error = "Hmm, that's not the right password. Please try again."
              } else {
                this.error = "Hmm, we've seemed to have an issue logging you in. Please try again."
              }
            });
        }
      }
    }
  }
</script>
